import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default {
  init: () => {
    gsap.utils.toArray("[data-parallax]").forEach((section) => {
      const parallaxItem = section.querySelectorAll("[data-parallax-item]");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          scrub: true,
          pin: false,
          onUpdate: (self) => {
            const progress = self.progress;
            const scale = 1 - progress * -0.8;
            const opacity = 1 - progress * 0.5;
          },
        },
      })

      parallaxItem.forEach((item) => {
        const badges = item.querySelector(".badges");

        tl.fromTo(item,
          { yPercent: -20, ease: "none" },
          { yPercent: 20, ease: "none" }
        );

        if (badges) {
          tl.fromTo(badges,
            { yPercent: 0, ease: "none" },
            { yPercent: -200, ease: "none" },
            0
          );
        }

      })
    })
  },

  handleParallaxGroup: () => {
    const sections = document.querySelectorAll("[data-parallax-group]");

    sections.forEach((section) => {
      const parent = section.parentElement;
      const nextElement = parent.nextElementSibling;
      const items = section.querySelectorAll("[data-parallax-group-item]");

      items.forEach((item) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
            end: "bottom 30%",
            pin: false,
            scrub: true,
          },
        });

        const images = item.querySelectorAll("img");

        images.forEach((image) => {
          tl.fromTo(image,
            { yPercent: -20, },
            { yPercent: 10 },
          );
        });
      });
    });
  },

  handleImageCardParallax: () => {
    const cards = document.querySelectorAll("[data-image-card-parallax]");

    cards.forEach((card) => {
      const item = card.querySelector("[data-parallax-item]");
      const image = item.querySelectorAll("img");
      const video = item.querySelector("video");

      const setParallaxValues = () => {
        const mobileView = window.innerWidth <= 768;

        if (mobileView) {
          gsap.set(image, { y: 50, scale: 1.4 });
          gsap.set(video, { y: 50, scale: 1.4 });
        } else {
          gsap.set(image, { y: 150, scale: 1.4 });
          gsap.set(video, { y: 150, scale: 1.4 });
        }
      };

      setParallaxValues();

      window.addEventListener("resize", () => {
        setParallaxValues();
      });

      gsap.to(image, {
        y: -50,
        ease: "none",
        scrollTrigger: {
          trigger: image,
          scrub: true,
          pin: false,
          start: "top 100%",
          end: "top 0%",
        },
      });

      gsap.to(video, {
        y: -50,
        ease: "none",
        scrollTrigger: {
          trigger: video,
          scrub: true,
          pin: false,
          start: "top 100%",
          end: "top 0%",
        },
      });
    })
  },
}
